export enum ApplicationId {
    SocialiteEvents = 1,
    SocialitePOS = 2,
    SocialiteResy = 3
}